import anime from 'animejs'
import {isMobile} from "../helpers"

export default () => ({
    hidden: false,
    mainTitle: null,
    secondaryTitle: 'test',
    titleHeight: null,
    titleNumberHeight: null,
    isStudio: false,
    async init() {


        this.titleHeight = getComputedStyle(document.documentElement).getPropertyValue('--page-title-transformation-height');
        this.titleNumberHeight = parseInt(this.titleHeight, 10);

        this.setupStyling();
        //     document.documentElement.style
        // .setProperty('--my-variable-name', 'pink');

        // getComputedStyle(document.documentElement)
        // .getPropertyValue('--my-variable-name'); // #999999

        // Should be enough to do this only once on init since the navigation
        // is a constant element and not part of any barba js container.
        this.mainTitle = this.$el.dataset.title;

        const secondary = anime({
            targets: this.$refs.secondaryTitle,
            translateY: -this.titleNumberHeight,
            duration: 0
        }).finished;

        const main = anime({
            targets: this.$refs.mainTitle,
            translateY: -this.titleNumberHeight,
            duration: 0
        }).finished;

        await Promise.all([main, secondary])


        if (window.location.href.indexOf("studio") != -1 && isMobile()) {

            await this.hidePageTitleTransformer();
            return
        }
        
        await this.showPageTitleTransformer();


    },

    setupStyling() {
        this.$refs.wrapper.style.height = this.titleHeight
        this.$refs.wrapper.style.lineHeight = this.titleHeight
        this.$refs.mainTitle.style.height = this.titleHeight
        this.$refs.mainTitle.style.lineHeight = this.titleHeight
        this.$refs.secondaryTitle.style.height = this.titleHeight
        this.$refs.secondaryTitle.style.lineHeight = this.titleHeight
    },

    onChangePageTitle(e) {

        this.changeTransition(e.detail);

        //const title = data.next.container.dataset.title
        //const menu = document.body.querySelector("#pagetitle");
        //menu.innerHTML = title

    },

    async changeTransition(title) {

        this.secondaryTitle = title;

        const main = anime({
            targets: this.$refs.mainTitle,
            translateY: 0,
            duration: 500,
            easing: 'linear'
        }).finished;

        const secondary = anime({
            targets: this.$refs.secondaryTitle,
            translateY: 0,
            duration: 500,
            easing: 'linear'
        }).finished;

        await Promise.all([main, secondary])

        this.mainTitle = this.secondaryTitle
        this.secondaryTitle = ""

        const secondaryA = anime({
            targets: this.$refs.secondaryTitle,
            translateY: -this.titleNumberHeight,
            duration: 0
        }).finished;

        const mainB = anime({
            targets: this.$refs.mainTitle,
            translateY: -this.titleNumberHeight,
            duration: 0
        }).finished;


        // e.detail
    },
    onNextPageTemplate(e) {
        if (isMobile() && e.detail === "STUDIO") {
            this.hidden = true;

            return;
        }
        if (isMobile() && e.detail === "CONTENT") {
            this.hidden = true;

            return;
        }

        this.hidden = false;
    },

    async onInfoModalOpen() {
        // this.hidden = true;
        await this.hidePageTitleTransformer();
    },
    async onInfoModalClose() {
        setTimeout(async () => {
            //this.hidden = false;
            await this.showPageTitleTransformer()
        }, 300);

    },
    async showPageTitleTransformer() {

        await anime({
            targets: this.$root,
            opacity: 1,
            delay: 0,
            duration: 0
        }).finished;

    },
    async hidePageTitleTransformer() {

        if (!isMobile()) return
        await anime({
            targets: this.$root,
            opacity: 0,
            delay: 0,
            duration: 0
        }).finished;
    }

})
